import _ from 'lodash';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Checkbox, CheckboxProps } from 'semantic-ui-react';
import styled from 'styled-components';

export const CheckboxSc = styled(Checkbox)`
  margin: 5px;
  margin-left: 0;

  &.ui.checkbox label,
  &.ui.checkbox + label {
    padding-left: 1.65714em;
  }

  &.ui.toggle.checkbox .box,
  &.ui.toggle.checkbox label {
    padding-left: 4.2rem;
  }
`;

interface CheckBoxProps extends FieldRenderProps {
  disabled?: boolean;
  disabledWhenFalse?: boolean;
  toggle?: boolean;
  label?: String;
}

const FinalFormCheckbox = (
    {
      input,
      disabledWhenFalse,
      disabled,
      ...restProps
    }: CheckBoxProps
) => {

  const isNullValue = _.isNil(input.value) || "" === input.value;
  let value = isNullValue ? "" : (!!input.value ? "true" : "false");

  return (
      <CheckboxSc
          label={restProps.label}
          toggle={restProps.toggle}
          checked={!!input.value}
          indeterminate={isNullValue}
          disabled={disabledWhenFalse && !input.value || disabled}
          {...input}
          {...restProps}
          onChange={(param: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
            let newValue: boolean | undefined | null = data.checked;
            if (isNullValue) {
              newValue = false;
            } else if (input.value === true && !data.checked) {
              newValue = null;
            }
            return input.onChange(newValue);
          }}
          value={value}
      />
  );
};

export default FinalFormCheckbox;
